<template src='./index.html'></template>
<script>
import { getdata } from './data';

export default {
    name: 'ywlxzt_ywgz_xjgz_jqsz',
    components: {},
    props: {
        rcszdialog: {
            type: Boolean,
            default: false
        },
        formData: {
            type: Array,
            default: []
        }
    },
    data: function() {
        return {
            form: {},
            conditionData: [{ id: '0' }],
            types: getdata().conditionOpTypes,
            rangeTypes: getdata().rangeOpTypes,
            rcszData: [],
            rcszDesc: "",
            saveClickFlag: false
        };
    },
    watch: {
        formData: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(function() {
                    if (this.formData && this.formData.length > 0) {
                        this.conditionData =  this.formData.filter(item => item.mode !=="03");
                        let data = this.formData.filter(item => item.mode ==="03"); // 百分比需要单独处理
                        data.forEach(item => {
                            let condition = {secStartValue: item.startValue, secEndValue: item.endValue, mode: item.mode};
                            this.conditionData.push(condition);
                        })
                    } else {
                        this.conditionData = [{ id: '0' }];
                    }
                });
            }
        }
    },
    mounted() {
    },
    created() {
    },
    methods: {
        closediag() {
            this.$emit('closediag', false);
        },
        addCondition() {
            // 新增容差
            this.conditionData.push({ id: 'add_' + this.conditionData.length });
        },
        deleteCondition(id) {
            this.conditionData = this.conditionData.filter(item => item.id !== id);
        },
        saveTolerance() {
            this.saveClickFlag = true;
            this.rcszData = [];
            this.conditionData.forEach(item => {
                if (item.mode === "05") {
                    // 固定值
                    let saveData = {};
                    saveData.type = '1'; // 类型为容差
                    saveData.mode = item.mode;
                    saveData.startValue = item.startValue;
                    saveData.endValue = item.endValue;
                    this.rcszData.push(saveData);
                    this.rcszDesc += "固定值：[" + saveData.startValue + "]至[" + saveData.endValue + "]；";
                } else if (item.mode === "04") {
                    // 固定精度
                    let saveData2 = {};
                    saveData2.type = '1'; // 类型为容差
                    saveData2.mode = item.mode;
                    saveData2.roundingType = item.roundingType;
                    saveData2.formatLength = item.formatLength;
                    this.rcszData.push(saveData2);
                    this.rcszDesc += "固定精度：[" + this.rangeTypes.filter(item => item.value === saveData2.roundingType)[0].label + "]请精确到小数点后[" + saveData2.formatLength + "]位；";
                } else if (item.mode === "03") {
                    // 百分比
                    let saveData3 = {};
                    saveData3.type = '1'; // 类型为容差
                    saveData3.mode = item.mode;
                    saveData3.startValue = item.secStartValue;
                    saveData3.endValue = item.secEndValue;
                    this.rcszData.push(saveData3);
                    this.rcszDesc += "百分比：[" + saveData3.startValue + "%]至[" + saveData3.endValue + "%]；";
                }
            });
            this.$emit('closediag', false);
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
